import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SliderComponent {
  sliderImages = [
    {
      slideSrc: 'assets/baner-strona1.jpg'
    },
    {
      slideSrc: 'assets/baner-strona2.jpg'
    }
  ];

  constructor(private router: Router) { }

  public goToPopular() {
    this.router.navigate(['/szukaj'], { queryParams: { popularSort: 'yes' } });
  }
}
